var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('payment-list',{attrs:{"loading":_vm.isLoading},model:{value:(_vm.payments),callback:function ($$v) {_vm.payments=$$v},expression:"payments"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }